import {fetchPost, generateEndpoint} from "../../../utils/request";

export const createMeasurement = async (measurement) => {
  const url = `${generateEndpoint('createMeasurement')}`
  return fetchPost(url, null, { measurement })
}
